import { isArray, isBoolean, isNumber, isString } from 'lodash'
import moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'
import { matchText } from 'modules/core/lib/stringUtils'

export type Value = any

export type DefaultEvaluatorFn = (value: Value, filterValue: Value) => boolean

const defaultEvaluators: Record<string, DefaultEvaluatorFn> = {
  is_empty: (value: Value): boolean => {
    if (isArray(value)) {
      return value.length === 0
    }

    return !value
  },
  is_not_empty: (value: Value): boolean => {
    if (isArray(value)) {
      return value.length !== 0
    }

    return !!value
  },
  is_equal: (value: Value, filterValue: Value): boolean => {
    if (isBoolean(value)) {
      filterValue = filterValue.toString() === 'true'
    }

    if (isNumber(value)) filterValue = parseInt(filterValue)

    if (isArray(value)) {
      if (isNumber(value[0])) filterValue = parseInt(filterValue)

      return value.includes(filterValue)
    }

    return value === filterValue
  },
  is_not_equal: (value: Value, filterValue: Value): boolean => {
    if (isNumber(value)) filterValue = parseInt(filterValue)

    if (isArray(value)) {
      if (isNumber(value[0])) filterValue = parseInt(filterValue)

      return !value.includes(filterValue)
    }

    return value !== filterValue
  },
  contains: (value: Value, filterValue: Value): boolean => {
    if (isString(value)) {
      return matchText(filterValue, value)
    }

    if (isArray(value)) {
      return value.includes(filterValue)
    }

    return false
  },
  not_contains: (value: Value, filterValue: Value): boolean => {
    if (isString(value)) {
      return !matchText(filterValue, value)
    }

    if (isArray(value)) {
      return !value.includes(filterValue)
    }

    return false
  },
  before: (value: Value, filterValue: Value): boolean => {
    const valueDate = moment(value).startOf('day')
    const filterValueDate = stringToDate(filterValue, 'ui').startOf('day')

    return valueDate.diff(filterValueDate, 'days') < 0
  },
  after: (value: Value, filterValue: Value): boolean => {
    const valueDate = moment(value).startOf('day')
    const filterValueDate = stringToDate(filterValue, 'ui').startOf('day')

    return valueDate.diff(filterValueDate, 'days') > 0
  },
  equal_before: (value: Value, filterValue: Value): boolean => {
    const valueDate = moment(value).startOf('days')
    const filterValueDate = stringToDate(filterValue, 'ui').startOf('days')

    return valueDate.diff(filterValueDate, 'days') <= 0
  },
  equal_after: (value: Value, filterValue: Value): boolean => {
    const valueDate = moment(value).startOf('days')
    const filterValueDate = stringToDate(filterValue, 'ui').startOf('days')

    return valueDate.diff(filterValueDate, 'days') >= 0
  },
  last_x_days: (value: Value, filterValue: Value): boolean => {
    const valueDate = moment(value).startOf('days')
    const filterValueDate = moment().startOf('days')

    return valueDate.diff(filterValueDate, 'days') <= filterValue
  },
  last_x_weeks: (value: Value, filterValue: Value): boolean => {
    const valueDate = moment(value).startOf('weeks')
    const filterValueDate = moment().startOf('weeks')

    return valueDate.diff(filterValueDate, 'weeks') <= filterValue
  },
}

export default defaultEvaluators
